<!--
* 组件名 : 绘画图轮播器
* 开发者 : LH
-->
<template>
  <section class="v-paint-viewer">
    <div ref="paintViewer" :style="styleObj">
      <div class="image-list" ref="imagesList">
        <img
          :data-src="get_md(item.max)"
          v-for="item in carousel"
          :key="item.slug"
        />
      </div>
      <div class="paint-box" ref="paintBox"></div>

      <controls :carousel="carousel" @close="on_close" @change="on_change" />
    </div>
  </section>
</template>

<script>
import { renderImage, i18n } from "@/utils/util";
import Viewer from "./viewer.esm";
import controls from "./compontents/controls/index";
import "./viewer.css";

export default {
  name: "v-paint-viewer",
  components: {
    controls,
  },
  props: {
    carousel: {
      type: Array,
      required: true,
    },
    current: {
      type: Number,
      default: 0,
    },
    isLargeImageOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let timer = null;
    return {
      isAnimate: false,
      currentData: this.current,
      styleObj: {},
    };
  },
  created() {
    this.set_background_color();
  },
  mounted() {
    let self = this;

    this.init_image_box_size();
    let currentImage = this.carousel[this.currentData];
    currentImage.mdLink = this.get_md(currentImage.max);
    currentImage.maxLink = this.get_link(currentImage.max);
    window.paintViewer = new Viewer(this.$refs.imagesList, {
      toolbar: false,
      title: false,
      navbar: false,
      button: false,
      backdrop: false,
      container: this.$refs.paintBox,
      loading: false,
      maxZoomRatio: 2,
      minZoomRatio: 0.5,
      zoomRatio: 0.5,
      initialViewIndex: this.currentData,
      view(ev) {
        window.clearTimeout(self.timer);
        self.timer = setTimeout(async () => {
          let max = ev.detail.image.src.replace("-md.jpg", ".jpg");
          await renderImage(currentImage.maxLink);
          ev.detail.image.src = max;
        });

        let current = self.carousel[ev.detail.index];
        window.paintViewerImageData = {
          image: i18n(current.min ?? current.max),
          imageMax: i18n(current.max),
          imageSlug: current.slug,
        };
      },
      url(img) {
        return img.dataset.src;
      },
      imageReady(a, b) {
        $(window).trigger(
          "_calcImgSizeAndPositionDone",
          Object.assign(a, {
            image: currentImage.mdLink,
            imageMax: currentImage.maxLink,
            imageSlug: currentImage.slug,
          })
        );
      },
    });
    window.paintViewer.show();

    $(window).one("attach_reactive_enter_animate_ended", () => {
      renderImage(currentImage.maxLink).then(() => {
        window.paintViewer.image.src = currentImage.maxLink;
      });
    });

    window.addEventListener("resize", this.init_image_box_size);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.init_image_box_size);
  },
  methods: {
    on_change(index) {
      this.$emit("change", index);
    },
    get_link(max) {
      return i18n(max);
    },
    get_md(max) {
      return this.isLargeImageOnly
        ? i18n(max)
        : i18n(max.replace(".jpg", "-md.jpg"));
    },
    set_background_color() {
      let chapterBgc = $(".pure-item").css("backgroundColor");
      this.styleObj = { "background-color": chapterBgc };
    },

    /**
     * 初始化外层容器的宽、高
     */
    init_image_box_size() {
      this.$refs.paintBox.style.width = `${window.innerWidth}px`;
      this.$refs.paintBox.style.height = `${window.innerHeight}px`;
    },
    /**
     * 下一张
     */
    on_next() {
      this.currentData++;
      this.carousel[this.currentData] &&
        renderImage(this.carousel[this.currentData + 1].max);
      this.$P.$emit("flickity_change", this.currentData);
    },
    on_prev() {
      this.currentData--;
      this.carousel[this.currentData] &&
        renderImage(this.carousel[this.currentData - 1].max);
      this.$P.$emit("flickity_change", this.currentData);
    },
    //  向paint-item组件传递关闭事件
    on_close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.v-paint-viewer {
  background: #c9e8f4;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  overflow-x: hidden;
  .image-list {
    display: none;
  }
  .image-box {
    position: relative;
  }

  &.fade-in {
    .paint-box,
    .controls {
      opacity: 0;
    }

    &.fade-in-done {
      .controls {
        transition: 0.3s;
      }
      .paint-box,
      .controls {
        opacity: 1;
      }
    }
  }
}
</style>
